const Testimonials = [
  {
    quote:
      '“Studio’s design and development capabilities are the best in the biz! They are creative, hard working, organized and extremely detail oriented. They finished every project on time and on budget and I would consider it an honor to work with them again in the future.”',
    citation: {
      name: 'Stacey Bendet',
      title: 'Creatively',
    },
  },
  {
    quote:
      '“Studio accelerated our development efforts and delivered a high quality product to market faster. They were collaborative with our product and design teams, great communicators, and guided prioritization to ensure we built features that resonate with users most.”',
    citation: {
      name: 'Naj Austin',
      title: 'Somewhere Good',
    },
  },
  {
    quote:
      '“Simply put, we needed a great teammate to take us to the next level and Studio was just that. With significant and varied experience designing and developing for the current state of mobile, they are smart A players in their respective areas of expertise.”',
    citation: {
      name: 'Rocky Collis',
      title: 'Mustard',
    },
  },
  {
    quote:
      '“Working with Studio has exceeded all of our expectations. They have blown us away at every turn with their diligent work ethic, unique point of view, and adaptability. We feel so grateful to have met Studio early on and to have them as part of our founding team.”',
    citation: {
      name: 'Chloe Harrouche',
      title: 'The Lanby',
    },
  },
]

export default Testimonials
